<template>
  <div id="app">
    <JpHeader v-if="!hideSiteChrome" />

    <div :class="['main-content', { 'main-content--bare': hideSiteChrome }]">
      <router-view />
    </div>

    <FloatingDownloadQr v-if="!hideSiteChrome" />
    <JpFooter v-if="!hideSiteChrome" />
  </div>
</template>

<script>
import JpHeader from './components/JpHeader.vue'
import JpFooter from './components/JpFooter.vue'
import FloatingDownloadQr from './components/FloatingDownloadQr.vue'

export default {
  name: 'App',
  components: {
    JpHeader,
    JpFooter,
    FloatingDownloadQr
  },
  computed: {
    hideSiteChrome() {
      return Boolean(this.$route.meta && this.$route.meta.hideSiteChrome)
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "PingFang SC", "Helvetica Neue", Arial, sans-serif;
  background: #fff;
  color: #333;
  line-height: 1.6;
}

#app {
  overflow-x: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.gradient-bg {
  background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 50%, #fff 100%);
  min-height: 100vh;
  position: relative;
}

.main-content {
  margin-top: 60px;
  min-height: calc(100vh - 60px - 300px);
}

.main-content--bare {
  margin-top: 0;
  min-height: 100vh;
}

@media (max-width: 768px) {
  .container {
    padding: 0 15px;
  }
}
</style>
